import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

const MentionsLegalesPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 pt-24" data-testid="mentions-legales-page">
      <div className="bg-white border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <nav className="flex items-center gap-2 text-sm">
            <Link to="/" className="text-gray-500 hover:text-orange-600">Accueil</Link>
            <ChevronRight className="w-4 h-4 text-gray-400" />
            <span className="text-orange-600 font-medium">Mentions Légales</span>
          </nav>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl font-bold text-gray-900 mb-4">Mentions Légales</h1>
        <p className="text-gray-600 mb-8">
          Conformément aux dispositions de la loi n° 2004-575 du 21 juin 2004 pour la Confiance dans l'Économie Numérique (LCEN), il est porté à la connaissance des utilisateurs et visiteurs du site barnum-evenement.fr les présentes mentions légales.
        </p>
        
        <div className="bg-white rounded-xl p-8 shadow-sm space-y-10 text-gray-700 leading-relaxed">

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">1. Éditeur du site</h2>
            <p>Le site <strong>barnum-evenement.fr</strong>, spécialisé dans la location de matériel événementiel en Normandie (barnums, chapiteaux, mobilier, décoration, sonorisation, éclairage, structures gonflables), est édité par :</p>
            <ul className="mt-4 space-y-2 ml-4">
              <li><strong>Raison sociale :</strong> SAS Barnum Événement &amp; Loisirs</li>
              <li><strong>Forme juridique :</strong> Société par Actions Simplifiée (SAS)</li>
              <li><strong>Siège social :</strong> 40 rue de la Libération, 76700 Gainneville, France</li>
              <li><strong>Téléphone :</strong> 06 98 43 09 92 (Mehdi) / 06 23 89 32 98 (Damien)</li>
              <li><strong>Email :</strong> <a href="mailto:contact@barnum-evenement.fr" className="text-orange-500 hover:underline">contact@barnum-evenement.fr</a></li>
              <li><strong>Activité :</strong> Location, livraison et installation de matériel événementiel pour particuliers et professionnels — mariages, séminaires, anniversaires, festivals, réceptions — dans toute la Normandie (Le Havre, Rouen, Caen, Dieppe, Honfleur, Étretat, Fécamp, Deauville, Lisieux et environs)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">2. Directeur de la publication</h2>
            <p>Le directeur de la publication du site barnum-evenement.fr est le représentant légal de la SAS Barnum Événement &amp; Loisirs.</p>
            <p className="mt-2">Contact : <a href="mailto:contact@barnum-evenement.fr" className="text-orange-500 hover:underline">contact@barnum-evenement.fr</a></p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">3. Hébergement</h2>
            <p>Le site barnum-evenement.fr est hébergé par :</p>
            <ul className="mt-3 space-y-1 ml-4">
              <li><strong>Hébergeur :</strong> Emergent Labs</li>
              <li><strong>Site web :</strong> emergentagent.com</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">4. Propriété intellectuelle</h2>
            <p>L'ensemble des éléments constituant le site barnum-evenement.fr (textes, descriptions de produits, photographies de chapiteaux et barnums, logos, graphismes, icônes, vidéos, mises en page) est la propriété exclusive de la SAS Barnum Événement &amp; Loisirs ou de ses partenaires.</p>
            <p className="mt-3">Toute reproduction, représentation, modification, publication, adaptation, totale ou partielle, de ces éléments, quel que soit le moyen ou le procédé utilisé, est strictement interdite sans l'autorisation écrite préalable de la SAS Barnum Événement &amp; Loisirs.</p>
            <p className="mt-3">Toute exploitation non autorisée du site ou de l'un quelconque des éléments qu'il contient sera considérée comme constitutive d'une contrefaçon et poursuivie conformément aux dispositions des articles L.335-2 et suivants du Code de la Propriété Intellectuelle.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">5. Limitation de responsabilité</h2>
            <p>La SAS Barnum Événement &amp; Loisirs s'efforce de fournir sur le site barnum-evenement.fr des informations aussi précises que possible concernant ses offres de location de matériel événementiel (chapiteaux, barnums, tentes pliantes, mobilier, vaisselle, éclairage, sonorisation, structures gonflables, matériel de restauration).</p>
            <p className="mt-3">Toutefois, elle ne pourra être tenue responsable des omissions, des inexactitudes et des carences dans la mise à jour, qu'elles soient de son fait ou du fait des tiers partenaires qui lui fournissent ces informations.</p>
            <p className="mt-3">Les prix et disponibilités affichés sur le site sont donnés à titre indicatif et peuvent être modifiés à tout moment. Seul un devis signé et validé engage les deux parties. Tous les tarifs s'entendent TTC pour la durée de location indiquée.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">6. Liens hypertextes</h2>
            <p>Le site barnum-evenement.fr peut contenir des liens hypertextes vers d'autres sites internet. La SAS Barnum Événement &amp; Loisirs n'exerce aucun contrôle sur le contenu de ces sites tiers et décline toute responsabilité quant à leur contenu.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">7. Données personnelles</h2>
            <p>Pour toute information relative à la collecte et au traitement de vos données personnelles, nous vous invitons à consulter notre <Link to="/confidentialite" className="text-orange-500 hover:underline">Politique de Confidentialité</Link>.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">8. Droit applicable et juridiction compétente</h2>
            <p>Les présentes mentions légales sont régies par le droit français. En cas de litige relatif à l'interprétation ou à l'exécution des présentes, et à défaut de résolution amiable, seuls les tribunaux du Havre seront compétents.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">9. Contact</h2>
            <p>Pour toute question ou demande d'information concernant le site, ou toute signalement de contenu illicite, vous pouvez nous contacter :</p>
            <ul className="mt-3 space-y-2 ml-4">
              <li><strong>Par email :</strong> <a href="mailto:contact@barnum-evenement.fr" className="text-orange-500 hover:underline">contact@barnum-evenement.fr</a></li>
              <li><strong>Par téléphone :</strong> 06 98 43 09 92 (Mehdi) / 06 23 89 32 98 (Damien)</li>
              <li><strong>Par courrier :</strong> SAS Barnum Événement &amp; Loisirs – 40 rue de la Libération, 76700 Gainneville</li>
            </ul>
          </section>

        </div>
      </div>
    </div>
  );
};

export default MentionsLegalesPage;
